// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../../shared/components/checkbox-list-with-label';
import ClaimTypes from '../../state/claim-types';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';

const CreditMemoClaimTypesCriteria = props => {

    const claimTypesSelectionMessage = props.claimTypes.selected.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (

        <div className='credit-memo-claim-types-criteria'>
            <CheckboxListWithLabel
                className='claim-types-criteria'
                initialState={createHashMap(props.claimTypes.selected, 'key')}
                isRequired={false}
                label='CLAIM_TYPES'
                list={addCollectionLabels(props.claimTypes.allowed, 'value')}
                onChange={props.handleClaimTypeSelect}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.handleAllClaimTypesSelect}
                type='button'
            >
                <FormattedMessage id={claimTypesSelectionMessage}/>
            </button>
        </div>

    );

};

CreditMemoClaimTypesCriteria.displayName = 'CreditMemoClaimTypesCriteria';
CreditMemoClaimTypesCriteria.propTypes = {
    claimTypes: PropTypes.instanceOf(ClaimTypes).isRequired,
    handleAllClaimTypesSelect: PropTypes.func.isRequired,
    handleClaimTypeSelect: PropTypes.func.isRequired
};

export default CreditMemoClaimTypesCriteria;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/claim-types-criteria.js